import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { registerRecoveryOtps } from '../api/registerRecoveryOtps'
import { apiRequest } from '../utils/apiRequest'
import { SETUP_MFA } from '../constants/routes'
import { SETTINGS_PAGE } from '../constants/links'
import { GENERIC_RECOVERY_CODES_ERROR_CODE } from '../constants/error.codes'
import { RECOVERY_OTP, navigateTo } from 'mfa'

// A user can land here without actually needing to set up MFA (back
// button, stale bookmark, already configured it in another tab): bounce
// them to Settings instead of showing the "you must set up MFA" prompt.
// Reads the user shape (mfa_enforced/local_login_enabled/enabled_mfa_mechanisms).
function shouldSetupMFA(user = {}) {
  const {
    mfa_enforced: mfaEnforced = false,
    local_login_enabled: isLocalLoginEnabled = false,
    enabled_mfa_mechanisms: enabledMFAMechanisms = [],
  } = user
  const hasMFAEnabled =
    enabledMFAMechanisms.filter((mfa) => mfa !== RECOVERY_OTP).length > 0 &&
    isLocalLoginEnabled
  return mfaEnforced && !hasMFAEnabled
}

// The enforced flow only ever needs to register recovery codes once, then
// hand off to the shared setup wizard.
export function useSetupMfaEnforced(user) {
  const navigate = useNavigate()
  const [errorCode, setErrorCode] = useState(null)

  useEffect(() => {
    if (!shouldSetupMFA(user)) navigateTo(SETTINGS_PAGE)
  }, [user])

  const setupMfa = useCallback(async () => {
    setErrorCode(null)
    try {
      const response = await apiRequest(registerRecoveryOtps)
      if (!response) return
      const { otps_list: recoveryCodeList } = response
      navigate(SETUP_MFA, {
        state: { recoveryCodeList, isFromSettings: false },
      })
    } catch (error) {
      setErrorCode(error.message || GENERIC_RECOVERY_CODES_ERROR_CODE)
    }
  }, [navigate])

  return { errorCode, setupMfa }
}
